/* AO - fill the store's review summary from Junip's live values.
 *
 * The markup is ours (snippets/ao-review-summary.liquid); the numbers are
 * Junip's. Their badge renders alongside it, hidden, purely as the data source.
 *
 * WHY READ THE ARIA-LABEL and not the visible text. Junip renders
 * "4.75 Rating | 15.81K reviews" for display - already rounded, already
 * formatted, and formatted differently in other locales. The anchor's
 * aria-label is the same figures unrounded and in a fixed sentence:
 *
 *   "Customer rating of 4.75 out of 5 stars based on 15812 reviews,
 *    powered by Junip. This link opens in a new tab."
 *
 * That gives the exact review count rather than "15.81K", and a rating we can
 * turn into a star width instead of a string to print.
 *
 * 🔴 IF NOTHING IS FOUND, NOTHING RENDERS. The summary starts `hidden` and is
 * only revealed once real values arrive. There is deliberately no fallback
 * number: a hard-coded rating that survives Junip being slow, broken or removed
 * is a review claim nobody checked, and it would look exactly like a working
 * one. An empty slot in the announcement bar costs nothing - it is absolutely
 * positioned, so its absence shifts no layout.
 */
(function () {
  if (window.AOReviewSummary) return;

  // Junip renders client-side and can take a second or so. Poll briefly rather
  // than racing it, then give up quietly.
  var POLL_MS = 250;
  var GIVE_UP_MS = 15000;

  var PATTERN = /rating of ([\d.]+) out of 5 stars based on ([\d,]+) reviews/i;

  function parse() {
    var anchors = document.querySelectorAll('.junip-badge-container[aria-label]');
    for (var i = 0; i < anchors.length; i++) {
      var match = String(anchors[i].getAttribute('aria-label')).match(PATTERN);
      if (!match) continue;

      var rating = parseFloat(match[1]);
      var count = parseInt(match[2].replace(/,/g, ''), 10);
      if (!isFinite(rating) || !isFinite(count) || count <= 0) continue;

      return { rating: rating, count: count, href: anchors[i].getAttribute('href') };
    }
    return null;
  }

  function render(data) {
    var slots = document.querySelectorAll('[data-ao-reviews]');
    if (!slots.length) return false;

    Array.prototype.forEach.call(slots, function (slot) {
      var fill = slot.querySelector('[data-ao-reviews-fill]');
      var text = slot.querySelector('[data-ao-reviews-text]');
      if (!fill || !text) return;

      // Clip the filled row to the rating. 4.75 of 5 is 95% of the row, which
      // lands three quarters of the way through the fifth star.
      fill.style.width = Math.max(0, Math.min(100, (data.rating / 5) * 100)) + '%';

      text.textContent =
        data.rating.toFixed(2).replace(/\.?0+$/, '') +
        ' · ' +
        data.count.toLocaleString() +
        ' reviews';

      if (data.href) slot.setAttribute('href', data.href);

      // The full sentence lives here, so the decorative star rows can stay
      // aria-hidden rather than being read out twice.
      slot.setAttribute(
        'aria-label',
        'Rated ' + data.rating + ' out of 5 from ' + data.count.toLocaleString() +
          ' customer reviews. Opens the review page in a new tab.'
      );

      slot.hidden = false;
    });

    return true;
  }

  var started = Date.now();

  function tick() {
    var data = parse();
    if (data && render(data)) return;
    if (Date.now() - started > GIVE_UP_MS) return;
    window.setTimeout(tick, POLL_MS);
  }

  window.AOReviewSummary = { parse: parse, render: render };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();
